import { Vendors } from '../enums';

export const removeCannedJobsModel = (vendor: Vendors) =>
    ![Vendors.mitchell, Vendors.roWriter].includes(vendor as Vendors);
